/** מפת סוגי שדה (מסמך Metadata פיירברי) */
export const FIREBERRY_FIELD_TYPE_PHONE = '3f62f67a-1cee-403a-bec6-aa02a9804edb';
export const FIREBERRY_FIELD_TYPE_SINGLE_LINE = 'a1e7ed6f-5083-477b-b44c-9943a6181359';
export const FIREBERRY_FIELD_TYPE_LOOKUP = 'a8fcdf65-91bc-46fd-82f6-1234758345a1';
export const FIREBERRY_FIELD_TYPE_NUMBER = '6a34bfe3-fece-4da1-9136-a7b1e5ae3319';
export const FIREBERRY_FIELD_TYPE_CHOICE = 'b4919f2e-2996-48e4-a03c-ba39fb64386c';
export const FIREBERRY_FIELD_TYPE_DATETIME = 'ce972d02-5013-46d4-9d1d-f09df1ac346a';
export const FIREBERRY_FIELD_TYPE_EMAIL = 'c713d2f7-8fa9-43c3-8062-f07486eaf567';
export const FIREBERRY_FIELD_TYPE_DATE_ONLY = '83bf530c-e04c-462b-9ffc-a46f750fc072';
export const FIREBERRY_FIELD_TYPE_URL = 'c820d32f-44df-4c2a-9c1e-18734e864fd5';
export const FIREBERRY_FIELD_TYPE_MULTILINE = '80108f9d-1e75-40fa-9fa9-02be4ddc1da1';

/** @deprecated השתמשו ב־FIREBERRY_FIELD_TYPE_DATETIME */
export const FIREBERRY_FIELD_TYPE_DATE = FIREBERRY_FIELD_TYPE_DATETIME;

export function normFireberryFieldTypeId(id: string | undefined): string {
  return String(id ?? '').trim().toLowerCase();
}

export const FIREBERRY_METADATA_TOKEN_STORAGE_KEY = 'broadcastWizard.fireberryMetadataToken';

/** לא להציג שוב את פופאפ מגבלת 1,000 נמענים (תפוצה מפיירברי) */
export const FIREBERRY_BROADCAST_1000_NOTICE_DISMISSED_KEY = 'broadcastWizard.fireberry1000LimitNoticeDismissed';

/** לא להציג שוב את פופאפ הסבר לערך פרמטר אחיד (שלב הגדרת פרמטרים בתפוצה) */
export const BROADCAST_UNIFORM_PARAM_NOTICE_DISMISSED_KEY = 'broadcastWizard.uniformParamNoticeDismissed';

/** שליפת רשומות לתפוצה — גודל דף לפי פרוקסי/Query; מקסימום שנשמר ב־UI */
export const FIREBERRY_QUERY_PAGE_SIZE = 500;
export const FIREBERRY_QUERY_MAX_RECORDS = 1000;

/**
 * פרוקסי Metadata לפיירברי.
 * override אופציונלי: VITE_FIREBERRY_METADATA_URL — לסביבות שדורשות כתובת אחרת.
 */
export const FIREBERRY_METADATA_DEFAULT_URL = 'https://fireberry.pbd.co.il';

/** נתיב same-origin — ב-dev נשלח דרך Vite proxy (ראה vite.config.mts). */
export const FIREBERRY_METADATA_SAME_ORIGIN_PATH = '/api/fireberry-metadata';

/**
 * מזהי אובייקט CRM (payload.objecttype) שלא להציג ולא לשלוח — למשל "7".
 *
 * לא לבלבל עם typeCode בפרוקסי: בשרת, 7 = GET רשומה בודדת; 10 = POST Query (ראה buildRequestByTypeCode).
 */
export const FIREBERRY_EXCLUDED_OBJECT_TYPES = new Set<string>(['7']);

/** typeCode לפי מסמך המשתמש */
export const FIREBERRY_TYPE = {
  get_objects: 1,
  get_object_fields: 2,
  get_field_details: 3,
  get_field_values: 4,
  get_object_views: 5,
  get_view_schema: 6,
} as const;

/**
 * פעולות רשומה בפרוקסי (אומתו מול השרת):
 * 7 = GET רשומה (objecttypecode + objectid), 8 = עדכון רשומה (objecttypecode + objectid + data),
 * 11 = יצירת רשומה (objecttypecode + data).
 */
export const FIREBERRY_RECORD_TYPE = {
  get_record: 7,
  update_record: 8,
  create_record: 11,
} as const;

/**
 * post_query בפרוקסי — case 10 (POST ל־/api/query/), גוף בתוך payload.criteria.
 * ברירת מחדל 10; לא 7 (בשרת 7 = GET רשומה לפי objectid + objecttypecode).
 */
export const FIREBERRY_POST_QUERY_TYPE_CODE = Number(
  import.meta.env.VITE_FIREBERRY_POST_QUERY_TYPE_CODE ?? 10,
);
